export default "__VITE_ASSET__DXQQQSQd__"